/**
 * Re-exports of api-side helpers so recorder modules don't pull in `lib/api.ts`
 * (which would create an import cycle: api.ts emits events → events fetch via api).
 */
export { getValidToken } from "@/lib/api";
export { getApiBase } from "@/lib/api-env";
